<template>
  <section class="aroma-home-stage" aria-label="睡眠阶段">
    <template v-if="timeline">
      <div class="aroma-home-stage__heading"><strong>睡眠阶段</strong><span>{{ timeline.start }}-{{ timeline.end }}</span></div>
      <div class="aroma-home-stage__bar">
        <span v-for="(item, index) in timeline.segments" :key="`${item.stage}-${index}`" :class="`is-${item.stage}`" :style="{ flexBasis: `${item.percent}%` }"></span>
      </div>
      <ul class="aroma-home-stage__legend">
        <li v-for="item in legend" :key="item.key"><i :class="`is-${item.key}`"></i>{{ item.label }}</li>
      </ul>
    </template>
    <div v-else class="aroma-home-stage__empty">暂无阶段数据</div>
  </section>
</template>

<script>
export default {
  name: 'AromaHomeStageTimeline',
  props: { timeline: { type: Object, default: null } },
  data () {
    return { legend: [
      { key: 'moderate', label: '准备入睡' },
      { key: 'light', label: '浅睡' },
      { key: 'deep', label: '深睡' },
      { key: 'awake', label: '清醒' }
    ] }
  }
}
</script>

<style scoped lang="scss">
.aroma-home-stage { padding: 14px; border: 1px solid #edf0f5; border-radius: 8px; background: #fafbff; }
.aroma-home-stage__heading { display: flex; align-items: center; justify-content: space-between; color: #8c93a1; font-size: 12px; }
.aroma-home-stage__heading strong { color: #30384d; font-size: 14px; }
.aroma-home-stage__bar { display: flex; height: 16px; margin-top: 12px; overflow: hidden; border-radius: 5px; }
.aroma-home-stage__bar span { min-width: 2px; }
.is-moderate { background: #c7cde1; }.is-light { background: #939efa; }.is-deep { background: #4457cc; }.is-awake { background: #f4ae4e; }
.aroma-home-stage__legend { display: grid; grid-template-columns: repeat(2,1fr); gap: 7px 16px; margin: 12px 0 0; padding: 0; color: #7f8796; font-size: 11px; list-style: none; }
.aroma-home-stage__legend li { display: flex; align-items: center; gap: 6px; }
.aroma-home-stage__legend i { width: 8px; height: 8px; border-radius: 50%; }
.aroma-home-stage__empty { padding: 28px 0; color: #a0a6b2; font-size: 13px; text-align: center; }
</style>
